import { FormControlLabel, Switch, Tooltip } from '@mui/material';
import { useTranslation } from '../../../hooks/useTranslation';

interface LiveSyncToggleProps {
  enabled: boolean;
  onChange: (enabled: boolean) => void;
  disabled?: boolean;
}

const LiveSyncToggle: React.FC<LiveSyncToggleProps> = ({
  enabled,
  onChange,
  disabled = false,
}) => {
  const { t } = useTranslation();

  return (
    <Tooltip
      title={t(
        'Automatically refresh data every 60 seconds for up to 10 minutes.'
      )}
      arrow
      placement="right"
    >
      <FormControlLabel
        control={
          <Switch
            checked={enabled}
            onChange={e => onChange(e.target.checked)}
            disabled={disabled}
            sx={{
              width: 42,
              height: 22,
              p: 0,
              '& .MuiSwitch-switchBase': {
                p: '2px',
                transitionDuration: '180ms',
                '&.Mui-checked': {
                  transform: 'translateX(20px)',
                  color: '#FFFFFF',
                  '& + .MuiSwitch-track': {
                    backgroundColor: '#2147F6',
                    opacity: 1,
                  },
                },
              },
              '& .MuiSwitch-thumb': {
                width: 18,
                height: 18,
                boxShadow: '0 1px 3px rgba(15, 23, 42, 0.25)',
              },
              '& .MuiSwitch-track': {
                borderRadius: 11,
                backgroundColor: '#D1D5DB',
                opacity: 1,
              },
            }}
          />
        }
        label={t('LIVE')}
        sx={{
          margin: 0,
          gap: 0.75,
          '& .MuiFormControlLabel-label': {
            fontFamily: 'var(--default-fonts)',
            fontSize: '0.8rem',
            fontWeight: 700,
            letterSpacing: '0.06em',
            color: enabled ? '#2147F6' : '#9CA3AF',
            transition: 'color 0.3s ease',
          },
        }}
      />
    </Tooltip>
  );
};

export default LiveSyncToggle;
